import { IGetMeResponse } from '@/types/response';

/** サーバーの PermissionKey（roles[].permissions[].key）と同じ値 */
export const PERMISSION = {
  ACCESS_ADMIN: 'accessAdmin',
  ACCESS_DASHBOARD: 'accessDashboard',
} as const;

export type PermissionKey = (typeof PERMISSION)[keyof typeof PERMISSION];

/** 権限の指定が無いページ・メニューは管理者専用（閲覧専用ロールには見せない） */
export const ADMIN_ONLY: PermissionKey[] = [PERMISSION.ACCESS_ADMIN];

/** ダッシュボードは管理者と閲覧専用ロール（DashboardViewer）の両方が見られる */
export const DASHBOARD_READERS: PermissionKey[] = [
  PERMISSION.ACCESS_ADMIN,
  PERMISSION.ACCESS_DASHBOARD,
];

/** いずれかの権限を持っていれば true */
export const hasAnyPermission = (
  user: IGetMeResponse | null,
  keys: PermissionKey[],
): boolean =>
  !!user?.roles?.some((role) =>
    role.permissions?.some((p) => keys.includes(p.key as PermissionKey)),
  );
